import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  selected: boolean
  children: React.ReactNode
  path: string
  iconsCombinationMessagesStyle?: boolean
  iconsCombinationUpdatesStyle?: boolean
  ariaLabel: string
}

const NotificationsIcons = ({
  selected,
  children,
  path,
  iconsCombinationMessagesStyle = false,
  ariaLabel,
}: Props) => {
  const navigate = useNavigate()

  return (
    <Box
      aria-label={ariaLabel}
      background="viridian1000"
      flexDirection="row"
      justifyContent="center"
      width="s32"
      paddingY="s4"
      paddingX="s6"
      borderRadius={{
        all: 'abs008',
      }}
      style={
        iconsCombinationMessagesStyle
          ? selected
            ? {
                position: 'absolute',
                top: '4px',
                left: '-58px',
                boxShadow:
                  '-10px 0px 5px 0px rgba(81,81,100, 0.8), 0.5px 0px 1px 0px rgba(81,81,100, 0.8)',
                zIndex: '3',
              }
            : {
                position: 'absolute',
                top: '4px',
                left: '-58px',
                boxShadow:
                  '-10px 0px 5px 0px rgba(255,255,255, 0.8), 0.5px 0px 1px 0px rgba(81,81,100, 0.8)',
                zIndex: '3',
              }
          : selected
            ? {
                position: 'absolute',
                top: '4px',
                right: '0',
                boxShadow: '-10px 0px 5px 0px rgba(81,81,100, 0.8)',
              }
            : {
                position: 'absolute',
                top: '4px',
                right: '0',
                boxShadow: '-10px 0px 5px 0px rgba(255,255,255, 0.8)',
              }
      }
      onClick={(e: MouseEvent) => {
        e.preventDefault()
        return navigate(path)
      }}
    >
      {children}
    </Box>
  )
}

export default observer(NotificationsIcons)
